module.exports = __webpack_public_path__ + "img/eligibilite2.631ced69.jpg";